import { useContext, memo } from "react";
import PropTypes from "prop-types";
import ProductCard from "app/pages/.shared/ProductCard/ProductCard";
import { productShape } from "app/utils/propTypes";
import { MembershipBlockContainer } from "app/features/membership";
import "./ProductList.scss";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import appGlobalsContext from "app/AppGlobalsContext";

const ProductList = ({
	products = [],
	hideMembershipBlock = false,
	hidePriceBanner,
	photoSizes,
}) => {
	const { resolution } = useContext(appGlobalsContext);
	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	return (
		<div className="product-list" data-testid="product-list">
			{products.map((product, index) => {
				return (
					<div
						key={`${product.id}-${product.uri ?? product.merchandising?.code ?? index}`}
						className="product-list__item"
						data-testid={`product-${
							product.uri || (product.merchandising && product.merchandising.code)
						}`}
					>
						<ProductCard
							isMobile={isMobile}
							product={product}
							position={index}
							hidePriceBanner={hidePriceBanner}
							photoSizes={photoSizes}
						/>
					</div>
				);
			})}
			{!hideMembershipBlock && (
				<div className="product-list__membership">
					<MembershipBlockContainer bleed="var(--space-s16)" memberColumns={2} />
				</div>
			)}
		</div>
	);
};

ProductList.propTypes = {
	products: PropTypes.arrayOf(productShape),
	hidePriceBanner: PropTypes.bool,
	hideMembershipBlock: PropTypes.bool,
	photoSizes: PropTypes.string,
};

export default memo(ProductList);
